<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId"
    [modalContainerAutomationId]="modalContainerAutomationId" [modalHelpIndex]="modalHelpIndex"
    [modalClass]="modalClass" [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()"
    (closeButtonActionEmt)="closeModal()" secondaryButtonLabel="Cancel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()"
    [maximizable]="true" [resizeHorizontal]="true" [resizeHorizontalMin]="resizeHorizontalMin" [resizeVertical]="true"
    [resizeVerticalMin]="600" [maximizableAutoId]="modalAutomationId">

    <res-data-area-and-tree id="dataAreaTree" isExportMode="true"
        [ngClass]="[modalType === 3 ? 'import-images-tree' :  'modal-fill']" [autoSelectFirstDA]="modalType !== 3"
        [automationId]="modalAutomationId" (onDAATChange)="onDataAreaAndTreeChange()"></res-data-area-and-tree>
    <div *ngIf="modalType === 2" class="load-from-options-container">
        <div class="button-group">
            <button [attr.data-automation-id]="modalAutomationId + '-docs-only-button'" type="button"
                [ngClass]="{true: 'btn-group-active', false: 'btn-group-default'}[loadOperationType == 'docs-only']"
                (click)="setLoadOperationType('docs-only')">
                <div>Reprocess Documents Only</div>
                <i class="fa fa-caret-up up-caret-active" [hidden]="loadOperationType != 'docs-only'"></i>
            </button>
            <button [attr.data-automation-id]="modalAutomationId + '-docs-with-children-button'" type="button"
                [ngClass]="{true: 'btn-group-active', false: 'btn-group-default'}[loadOperationType == 'docs-with-children']"
                (click)="setLoadOperationType('docs-with-children')">
                <div>Reprocess Documents with Children</div>
                <i class="fa fa-caret-up up-caret-active" [hidden]="loadOperationType != 'docs-with-children'"></i>
            </button>
            <button [attr.data-automation-id]="modalAutomationId + '-external-ocr-text-button'" type="button"
                [ngClass]="{true: 'btn-group-active', false: 'btn-group-default'}[loadOperationType == 'external-ocr']"
                (click)="setLoadOperationType('external-ocr')">
                <div>Load External OCR Text</div>
                <i class="fa fa-caret-up up-caret-active" [hidden]="loadOperationType != 'external-ocr'"></i>
            </button>
        </div>
        <div *ngIf="loadOperationType === 'docs-only'" class="docs-only-container">
            <res-custom-checkbox [automationId]="modalAutomationId + '-docs-only-update-native-files'"
                [(ngModel)]="docsOnlyUpdateNative" content="Update Native Files"></res-custom-checkbox>
        </div>
        <div *ngIf="loadOperationType === 'docs-with-children'" class="docs-with-children-container">
            <res-custom-checkbox [automationId]="modalAutomationId + '-sync-to-project-data'"
                [(ngModel)]="syncToProjectData" content="Sync Document Children to Project Data"></res-custom-checkbox>
            <div class="tag-selection-container">
                <res-custom-checkbox [automationId]="modalAutomationId + '-apply-parent-tags-to-children'"
                    [disabled]="!syncToProjectData" [(ngModel)]="applyParentTags"
                    content="Apply Parent Tags to Children"></res-custom-checkbox>
                <div class="tag-group">
                    <res-custom-checkbox [automationId]="modalAutomationId + '-apply-new-tags-to-children'"
                        [(ngModel)]="applyNewTags" content="Apply New Tags to Children" [disabled]="!syncToProjectData">
                    </res-custom-checkbox>
                    <button class="secondary-button" [disabled]="!applyNewTags || !syncToProjectData"
                        (click)="openTagSelector()"
                        [attr.data-automation-id]="modalAutomationId + '-select-tags-button'">
                        <i class="fa fa-tags color-blue-01"></i>
                        <span>Select Tags ...</span>
                    </button>
                    <span [ngClass]="{'disabled': !applyNewTags || !syncToProjectData}" class="selected-tags">Selected:
                        <span
                            [attr.data-automation-id]="modalAutomationId + '-selected-tags-number'">{{getSelectedTagsNo()}}</span></span>
                </div>
            </div>
            <res-custom-checkbox [automationId]="modalAutomationId + '-docs-with-children-update-native-files'"
                [(ngModel)]="docsWithChildrenUpdateNative" content="Update Native Files"></res-custom-checkbox>
        </div>
    </div>
    <div *ngIf="modalType === 3" class="import-external-files-container modal-fill">
        <res-resizer [attr.data-automation-id]="modalAutomationId + '-resizer-button'" anchor="left"
            resizingElementId="dataAreaTree" secondElementId="dataAreaPath" [usePercentages]="true" [initSize]="60"
            [minSize]="20" [maxSize]="80" [ellipsisExpander]="true"></res-resizer>
        <div class="grid-path-container">
            <res-generic-grid #filesGrid id="dataAreaPath" [automationId]="modalAutomationId"
                [updateStatusType]="filesGridUpdateStatusType" [rowSelection]="filesGridRowSelection"
                [pagerVisible]="false" [(isBusy)]="isFilesBusy" [(isBusyMessage)]="isFilesBusyMessage"
                [columnDefs]="filesGridColumnDefs" [requestInfo]="fileGridRequestInfo"
                [responseArrayFilter]="filesGridResponseArrayFilter" [onSelectionChanged]="filesGridOnSelectionChanged"
                [gridContext]="filesGridContext">
            </res-generic-grid>
            <div class="file-grid-path-container">
                <label for="filePathInput">Path:</label>
                <input type="text" name="filePath" id="filePathInput" [(ngModel)]="selectedFile.name" readonly
                    [attr.data-automation-id]="modalAutomationId + '-path-input'" />
            </div>
        </div>
    </div>
</res-base-modal>